import {Color} from '~/constants/style';
import {DOT_RADIUS, INNER_CIRCLE_RADIUS} from '../../../constant';

type DotProps = {
  cx?: number;
  cy?: number;
};

export const CustomDot = ({cx = 0, cy = 0}: DotProps) => {
  return (
    <g>
      <circle cx={cx} cy={cy} r={DOT_RADIUS} fill={Color.Purple600} />
      <circle cx={cx} cy={cy} r={INNER_CIRCLE_RADIUS} fill={Color.White} />
    </g>
  );
};
